import React, { Component } from 'react';
import PropTypes, { bool } from 'prop-types';
import uniqueid from '../uniqueid';
import Dropdown from '../Dropdown/Dropdown';
import Button from './Button';

class ButtonWithDropdown extends Component {
    renderDropdown = () => {
        const { dropdownItems } = this.props;
        return dropdownItems.map((item) => (
            <React.Fragment key={`dropdown-${item.type || 'item'}-${uniqueid('')}`}>
                {item.separatorTop && <Dropdown.Separator testId={item.testId} />}
                {item.type === 'confirm' && (
                    <Dropdown.ConfirmButtonItem
                        btnIcon={item.icon}
                        btnLabel={item.label}
                        confirmLabel={item.confirmLabel}
                        onConfirm={item.onConfirm}
                        testId={item.testId}
                    />
                )}
                {item.type === 'button' && (
                    <Dropdown.ButtonItem
                        btnIcon={item.icon}
                        btnLabel={item.label}
                        onClick={item.onClick}
                        testId={item.testId}
                    />
                )}
                {(item.type === 'item' || !item.type) && (
                    <Dropdown.Item testId={item.testId}>{item.label}</Dropdown.Item>
                )}
            </React.Fragment>
        ));
    };

    render() {
        const { btnProps, dropdownProps, dropdownDirection, testId, disabled } = this.props;
        return (
            <div className="btn--multi-options">
                <Button disabled={disabled} {...btnProps} testId={`${testId}-button`} />
                <Dropdown disabled={disabled} {...dropdownProps} testId={`${testId}-dropdown`}>
                    <Dropdown.Menu direction={dropdownDirection} testId={`${testId}-menu`}>
                        {this.renderDropdown()}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }
}

ButtonWithDropdown.propTypes = {
    testId: PropTypes.string,
    btnProps: PropTypes.object,
    dropdownProps: PropTypes.object,
    dropdownDirection: PropTypes.string,
    dropdownItems: PropTypes.array,
    disabled: bool,
};

ButtonWithDropdown.defaultProps = {
    testId: 'button-with-dropdown',
    btnProps: {},
    dropdownProps: {},
    dropdownItems: [],
    dropdownDirection: 'se',
    disabled: false,
};

export default ButtonWithDropdown;
